import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import withLocalization from '../../../hoc/withLocalization';
import Select from '../../../elements/Select';

const NOTE = 'No Work Plan Setup';

const DepartmentSelectInner = inject('commonStore', 'clientStore')(withLocalization(observer(class DepartmentSelectInner extends Component {
    formatOptionLabel = ({ value, label }, { context }) => {
        const { commonStore, clientStore, t } = this.props;
        const allowCompanyShifts = commonStore?.config?.client?.allow_company_shifts;
        if (context === 'value' || !allowCompanyShifts) {
            return <span className='fw-600'>{label}</span>;
        }
        const workHoursRule = clientStore?.workHoursRule || [];
        const hasRule = workHoursRule.some(r => r.department === value);
        return (
            <span>
                {label}
                {!hasRule && (
                    <span style={{ color: 'red', fontSize: '12px' }}>{` (${t(NOTE)})`}</span>
                )}
            </span>
        );
    };

    render() {
        const { value, onChange, options, schema } = this.props;
        const enumOptions = options?.enumOptions || [];
        const selectOptions = enumOptions.map(o => ({ value: o.value, label: o.label }));
        const selected = selectOptions.find(o => o.value === value) || null;
        const isDisabled = !!schema?.readOnly;

        return (
            <Select
                options={selectOptions}
                value={selected}
                isDisabled={isDisabled}
                onChange={opt => onChange(opt ? opt.value : '')}
                formatOptionLabel={this.formatOptionLabel}
                style={{ width: '100%' }}
            />
        );
    }
})));

export class DepartmentSelectWidget extends Component {
    render() {
        return <DepartmentSelectInner {...this.props} />;
    }
}
